export const emptyNotificationsState = {
  all: [],
  listLoaded: false,
  unreadCounter: 0,
  unseenCounter: 0,
  counterMutationSeq: 0,
  seenMutationSeq: 0
}
